import styled from "styled-components";
import { DashboardLayout } from "src/components/dashboard";
import { BookingsTabs } from "src/components/bookings";
import { Input } from "src/components/inputs";
import searchIcon from "src/assets/images/input/searchIcon.svg";
import React, { useEffect, useState } from "react";
import { Button, ButtonClass, Flex } from "src/components/ui";
import { BookingStatus } from "src/components/bookings";
import { useNavigate, useSearchParams } from "react-router-dom";
import { formatDate, formatDateDmy } from "src/utils/helpers";
import { Loader } from "src/components/common";
import { toast, ToastContainer } from "react-toastify";
import { theme } from "src/styles/Theme";
import Tab from "@mui/material/Tab";
import TabContext from "@mui/lab/TabContext";
import TabList from "@mui/lab/TabList";
import { PaginationProps } from "src/components/ui/Pagination";
import {
  useBookingHistoryQuery,
  useLazyExportBookingsQuery,
} from "src/store/services/bookingApi";

const BookingsPageContainer = styled.div``;

interface Props {
  handleChange: (e: any) => void;
  onClick: () => void;
  exportingBookings: boolean;
}

const initialAddressState = {
  city: "",
  state: "",
  house_address: "",
};

const initialMetaState = {
  call_out_fee: 0,
  display_picture: "",
  first_name: "",
  last_name: "",
  phone: "",
  rating: "",
  address: initialAddressState,
  business_name: "",
  shop_address: "",
};

const CategoryTypes = {
  _id: "",
  name: "",
  description: "",
  image_url: "",
};

const initialBookingState = {
  artisan_id: "",
  booking_type: "",
  city: "",
  service: "",
  state: "",
  status: "",
  createdAt: "",
  user_id: "",
  description: "",
  end_date: "",
  start_date: "",
  fees: {
    commitment_fee: {
      amount: 0,
      status: "",
    },
    service_fee: {
      amount: 0,
      status: "",
    },
    facilitation_fee: {
      amount: 0,
      status: "",
    },
  },
  artisan_meta: initialMetaState,
  user_meta: initialMetaState,
  category: CategoryTypes,
};
export default function BookingsPage() {
  const navigate = useNavigate();
  const [bookingDetails, setBookingDetails] = useState<BookingsTypes[]>([
    initialBookingState,
  ]);
  const [searchField, setSearchField] = useState("");
  const [pageNo, setPageNo] = useState(1);
  const [paginationData, setPaginationData] = useState<PaginationProps>({
    page: 0,
    pageSize: 0,
    total: 0,
    totalPages: 0,
  });
  const [exportingBookings, setExportingBookings] = useState(false);
  const [bookingType, setBookingType] = useState("all");
  const [page, setPage] = useState(1);
  //   const limit = 12;

  // Set document title
  useEffect(() => {
    document.title = "Booking's Page";
  }, []);

  // Get booking type from URL params

  const [searchParams, setSearchParams] = useSearchParams();
  const tabStatus = searchParams.get("tabStatus"); 
  const [status, setStatus] = useState(tabStatus || '');
  const [startDate, setStartDate] = useState<Date>(() => {
    const date = new Date();
    date.setFullYear(2020, 0);
    return date;
  });
  const [endDate, setEndDate] = useState<Date>(new Date());
  // useEffect(() => {
  //   const typeParam = searchParams.get("bookingType");
  //   if (typeParam === "partner" || typeParam === "individual") {
  //     setBookingType(typeParam);
  //   } else {
  //     setBookingType("all");
  //   }
  // }, [searchParams]);

  // Build query params for API

  
  useEffect(() => {
    setPageNo(1);
    console.log(bookingType)
  }, [status, bookingType, startDate, endDate]);

  const queryParams: {
    booking_type: string;
    page?: number;
    limit?: number;
    search?: string;
    status?: string;
    endDate?: Date;
    startDate?: Date;
  } = {
    page: pageNo,
    limit: 10,
    search: searchField,
    status: status === "all" ? "" : status,
    endDate: endDate,
    startDate: startDate,
    booking_type: bookingType === "all" ? "" : bookingType,
  };
  

  
    console.log(bookingType)

  // Fetch bookings
  const { data: bookingsResp, isFetching: isLoadingBookings } = useBookingHistoryQuery(queryParams);

  // Update local state for table
  useEffect(() => {
    
    console.log(bookingType)
    setBookingDetails(bookingsResp?.payload?.data || []);
    setPaginationData(bookingsResp?.payload?.pagination);
    
    console.log(bookingType)
  }, [bookingsResp]);

  // Example: Pagination handler
  const handlePageChange = (newPage: number) => {
    setPage(newPage);
  };

  // RTK: export bookings
  const [triggerExportBookings] = useLazyExportBookingsQuery();
  const exportBookings = async () => {
    setExportingBookings(true);
    try {
      const exportParams: { booking_type?: string } = {};
      if (bookingType !== "all") {
        exportParams.booking_type = bookingType;
      }
      const res: any = await triggerExportBookings(exportParams).unwrap();
      const url = res?.payload?.data?.fileUrl;
      if (url) window.open(url, "_blank");
    } catch (err: any) {
      toast.error(err?.data?.error?.message || "Export failed");
    } finally {
      setExportingBookings(false);
    }
  };

  const filteredData = bookingDetails.filter((data) => {
    return (
      data?.user_meta?.first_name
        .toLowerCase()
        .includes(searchField.toLowerCase()) ||
      data?.user_meta?.last_name
        .toLowerCase()
        .includes(searchField.toLowerCase()) ||
      data?.service.toLowerCase().includes(searchField.toLowerCase()) ||
      data?.city.toLowerCase().includes(searchField.toLowerCase()) ||
      data?.state.toLowerCase().includes(searchField.toLowerCase()) ||
      data?.artisan_meta?.first_name
        .toLowerCase()
        .includes(searchField.toLowerCase()) ||
      data?.artisan_meta?.last_name
        .toLowerCase()
        .includes(searchField.toLowerCase())
    );
  });

  const handleChange = (e: any) => {
    setSearchField(e.target.value);
  };

  const handleBookingTypeChange = (
    event: React.SyntheticEvent,
    newValue: string,
  ) => {
    const newType = newValue as "" | "partner" | "individual";
    setBookingType(newType);
    // setPageNo(1)
    const params = new URLSearchParams(searchParams);
    if (newType === "") {
      params.delete("bookingType");
    } else {
      params.set("bookingType", newType);
    }
    setSearchParams(params);
  };

  const handleNavigate = (row: { [x: string]: any }) => {
    const currentTabStatus = searchParams.get("tabStatus") || "all";
    navigate(`/bookings/${row?._id}?tabStatus=${row?.status}`, {
      state: { fromTab: currentTabStatus },
    });
  };
  let buss_type = "";
  if (bookingType == "all") {
    buss_type = "Vendor/Partners";
  } else if (bookingType == "individual") {
    buss_type = "Vendor";
  } else if (bookingType == "partner") {
    buss_type = "Partners";
  }

  const BookingsTableHeaders = [
    {
      title: "Customer",
      render: (row: BookingsTypes) => (
        <Flex gap="10px" align="center">
          <img
            style={{ width: 40, height: 40, borderRadius: "50%" }}
            src={row.user_meta.display_picture}
            alt=""
          />{" "}
          <div>
            <p>
              {row.user_meta.first_name} {row.user_meta.last_name}
            </p>
            <p>{row.user_meta.phone}</p>
          </div>
        </Flex>
      ),
    },
    {
      title: buss_type,
      render: (row: BookingsTypes) => (
        <Flex gap="10px" align="center">
          <img
            style={{ width: 40, height: 40, borderRadius: "50%" }}
            src={row.artisan_meta.display_picture}
            alt=""
          />{" "}
          <div>
            <p>
              {row?.booking_type === "individual"
                ? `${row?.artisan_meta?.first_name} ${row?.artisan_meta?.last_name}`
                : row?.artisan_meta?.business_name}
            </p>
            <p>{row.artisan_meta.phone}</p>
          </div>
        </Flex>
      ),
    },
    {
      title: "Category",
      render: (row: BookingsTypes) => `${row.category?.name || row.service}`,
    },
    {
      title: "Location",
      render: (row: BookingsTypes) => `${row.city}, ${row.state}`,
    },
    {
      title: "Start Date",
      render: (row: BookingsTypes) => formatDate(row.start_date),
    },
    {
      title: "End Date",
      render: (row: BookingsTypes) => formatDate(row.endDate),
    },
    {
      title: "Status",
      render: (row: BookingsTypes) => <BookingStatus status={row.status} />,
    },
  ];

  return (
    <DashboardLayout
      pageTitle="Bookings"
      rhsHeading={
        <RhsHeading
          handleChange={handleChange}
          onClick={exportBookings}
          exportingBookings={exportingBookings}
        />
      }
    >
      <ToastContainer />
      <BookingsPageContainer>
        {/* Booking Type Tabs */}
        <div className="flex items-center bg-white rounded-lg p-4 mb-4 border border-[#e0e0e0] mt-8">
          {isLoadingBookings ? (
            <div className="flex gap-4 w-full">
              <div className="h-10 w-20 bg-gray-200 rounded animate-pulse"></div>
              <div className="h-10 w-24 bg-gray-200 rounded animate-pulse"></div>
              <div className="h-10 w-28 bg-gray-200 rounded animate-pulse"></div>
            </div>
          ) : (
            <TabContext value={bookingType}>
              <TabList
                onChange={handleBookingTypeChange}
                aria-label="booking type tabs"
                sx={{
                  borderBottom: "1px solid #e0e0e0",
                  "& .MuiTabs-indicator": {
                    backgroundColor: theme.colors.purple,
                    height: "3px",
                  },
                  "& .MuiTab-root": {
                    textTransform: "capitalize",
                    fontSize: "15px",
                    fontWeight: 500,
                    minHeight: "48px",
                    color: "#6b6675",
                    "&.Mui-selected": {
                      color: theme.colors.purple,
                      fontWeight: 600,
                    },
                  },
                }}
              >
                <Tab label="All" value="all" />
                <Tab label="Partner" value="partner" />
                <Tab label="Vendor" value="individual" />
              </TabList>
            </TabContext>
          )}
        </div>

        {isLoadingBookings ? (
          <div className="bg-white rounded-xl overflow-hidden shadow-sm border border-black">
            <div className="p-6">
              {/* Title Skeleton */}
              <div className="mb-4">
                <div className="h-6 w-32 bg-gray-200 rounded animate-pulse"></div>
              </div>

              {/* Table Header Skeleton */}
              <div className="grid grid-cols-8 gap-4 pb-4 border-b border-gray-200 mb-4">
                <div className="h-4 bg-gray-200 rounded animate-pulse"></div>
                <div className="h-4 bg-gray-200 rounded animate-pulse"></div>
                <div className="h-4 bg-gray-200 rounded animate-pulse"></div>
                <div className="h-4 bg-gray-200 rounded animate-pulse"></div>
                <div className="h-4 bg-gray-200 rounded animate-pulse"></div>
                <div className="h-4 bg-gray-200 rounded animate-pulse"></div>
                <div className="h-4 bg-gray-200 rounded animate-pulse"></div>
                <div className="h-4 bg-gray-200 rounded animate-pulse"></div>
              </div>

              {/* Table Rows Skeleton */}
              {[...Array(5)].map((_, index) => (
                <div
                  key={index}
                  className="grid grid-cols-8 gap-4 py-4 border-b border-gray-100 last:border-b-0"
                >
                  {/* Customer */}
                  <div className="flex items-center gap-2">
                    <div className="w-10 h-10 bg-gray-200 rounded-full animate-pulse"></div>
                    <div className="flex-1">
                      <div className="h-4 bg-gray-200 rounded w-24 mb-2 animate-pulse"></div>
                      <div className="h-3 bg-gray-200 rounded w-20 animate-pulse"></div>
                    </div>
                  </div>
                  {/* Vendor */}
                  <div className="flex items-center gap-2">
                    <div className="w-10 h-10 bg-gray-200 rounded-full animate-pulse"></div>
                    <div className="flex-1">
                      <div className="h-4 bg-gray-200 rounded w-24 mb-2 animate-pulse"></div>
                      <div className="h-3 bg-gray-200 rounded w-20 animate-pulse"></div>
                    </div>
                  </div>
                  {/* Service */}
                  <div className="flex items-center">
                    <div className="h-4 bg-gray-200 rounded w-20 animate-pulse"></div>
                  </div>
                  {/* Location */}
                  <div className="flex items-center">
                    <div className="h-4 bg-gray-200 rounded w-24 animate-pulse"></div>
                  </div>
                  {/* Start Date */}
                  <div className="flex items-center">
                    <div className="h-4 bg-gray-200 rounded w-20 animate-pulse"></div>
                  </div>
                  {/* End Date */}
                  <div className="flex items-center">
                    <div className="h-4 bg-gray-200 rounded w-20 animate-pulse"></div>
                  </div>
                  {/* Fees */}
                  <div className="flex items-center">
                    <div className="h-4 bg-gray-200 rounded w-32 animate-pulse"></div>
                  </div>
                  {/* Status */}
                  <div className="flex items-center">
                    <div className="h-6 bg-gray-200 rounded-full w-16 animate-pulse"></div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        ) : filteredData.length > 0 ? (
          <BookingsTabs
            rows={filteredData}
            BookingsTableHeaders={BookingsTableHeaders}
            title={
              <p className="count">
                {paginationData.total > 1
                  ? paginationData.total + " Bookings"
                  : paginationData.total + " Booking"}
              </p>
            }
            onRowClick={handleNavigate}
            searchParams={searchParams}
            setSearchParams={setSearchParams}
            setStatus={setStatus}
            paginationData={paginationData}
            pgn={pageNo}
            setpgn={setPageNo}
            setEndDate={setEndDate}
            setStartDate={setStartDate}
          />
        ) : (
          <p className="table-entry-status">No Bookings Found</p>
        )}
      </BookingsPageContainer>
    </DashboardLayout>
  );
}

export const RhsHeading: React.FC<Props> = ({
  handleChange,
  onClick,
  exportingBookings,
}) => (
  <Flex wrap="wrap">
    <Button
      onClick={onClick}
      classes={[ButtonClass.SOLID, ButtonClass.WITH_ICON]}
      style={{
        backgroundColor: theme.colors.purple,
        height: "48px",
        minWidth: "145px",
      }}
    >
      {exportingBookings ? <Loader>Exporting...</Loader> : <span>Export</span>}
    </Button>
    <Input
      icon={<img src={searchIcon} alt="searchIcon" />}
      type="search"
      placeholder="Search"
      handleChange={handleChange}
    />
  </Flex>
);
